// extracted by mini-css-extract-plugin
export var audioPlayer = "_tm-0";